const initializeProjectLoader = (editor,setDisplaySpinner) =>{

    editor.on('update',() => {
        setDisplaySpinner(false);
        editor.Commands.stop('enable-clear-page');
    })
}

export default initializeProjectLoader;
